import { render, staticRenderFns } from "./MenuLateral.vue?vue&type=template&id=2931dc21&scoped=true&"
import script from "./MenuLateral.vue?vue&type=script&lang=js&"
export * from "./MenuLateral.vue?vue&type=script&lang=js&"
import style0 from "./MenuLateral.vue?vue&type=style&index=0&id=2931dc21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931dc21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDivider,VList,VListGroup,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer})
